// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"671":"a700a07d","3100":"62f44845","6755":"0e38c1cd"}[chunkId] + ".chunk.css";
};